import _ from 'lodash'
import { useContext, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useAppSelector } from '@/redux/rootReducer'
import { selectMeetingLinkByName } from '@/redux/reducers/meeting-link.reducer'

import Map from '../components/Map'
import { BookingPageContext } from '../BookingPage'

export default function MapContainer() {
  const { meetingLinkName } = useParams()
  const { address } = useContext(BookingPageContext)

  const meetingLink = useAppSelector((state) => selectMeetingLinkByName(state, meetingLinkName))

  const establishmentPlaces = useMemo(
    () => {
      const places: string[] = []
      const addresses = _.map(meetingLink?.availabilities, 'address')
      for (const address of addresses) {
        if (address !== null && address !== undefined) places.push(address.placeId)
      }
      return places
    },
    [meetingLink]
  )

  return <Map home={address?.placeId || undefined} places={establishmentPlaces} />
}
